import React, { useEffect, useRef, useState } from "react";
import { Input } from "antd";
import { EditOutlined } from "@ant-design/icons";
import SC from "./style";

const { TextArea } = Input;

const TableTextInput = (props) => {
  const {
    defaultValue = "",
    name,
    onChange = () => {},
    variant = "outlined",
    disabled = false,
    suffix,
    style,
    size = "small",
    type,
    min,
    max,
    placeholder,
    addonbefore,
    addonafter,
    status = "none",
    prefix,
    isError = false,
    isTextArea = false,
    required = false,
    focus = false,
    autoFocus = false,
  } = props;

  const [focused, setFocused] = useState(focus);
  const [value, setValue] = useState(defaultValue);
  const [hover, setHover] = useState(false);
  const [isDisabled, setIsDisabled] = useState(!focus);
  const inputRef = useRef(null);

  const sharedProps = {
    ref: inputRef,
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    if (isError) {
      setValue(defaultValue);
      setFocused(true);
      setIsDisabled(false);
    }
  }, [isError]);

  const handleKeyPress = (e) => {
    if (defaultValue !== value) {
      onChange(value, name);
    }
    setFocused(false);
    setIsDisabled(true);
  };

  const handleBlur = (e) => {
    setTimeout(() => {
      handleKeyPress(e);
    }, 100); // Set a minimal timeout
  };

  const handleFocus = () => {
    setFocused(true);
  };

  const validateValue = (val) => {
    if (type === "number") {
      return Math.max(val, 1);
    }
    return val;
  };

  const handleChange = (e) => {
    let { value } = e.target;
    value = validateValue(value);
    setValue(value);
  };

  return (
    <>
      {SC.GlobalStyles}
      <SC.Wrapper
        onMouseEnter={() => setHover(true)} // Handle hover state
        onMouseLeave={() => {
          setHover(false);
          setFocused(false);
          setIsDisabled(true);
          handleBlur("e");
        }}
      >
        {isTextArea ? (
          <TextArea
            {...sharedProps}
            value={value}
            min={min}
            max={max}
            placeholder={placeholder}
            size={size}
            name={name}
            variant={focused || isError ? "outlined" : variant}
            onPressEnter={handleKeyPress}
            onBlur={(e) => handleBlur(e)}
            onFocus={handleFocus}
            onChange={handleChange}
            style={style}
            disabled={isDisabled}
            suffix={suffix}
            addonbefore={addonbefore}
            addonafter={addonafter}
            status={isError ? "error" : undefined}
            prefix={prefix}
            required={required}
            autoFocus={autoFocus}
            autoSize={focused}
          />
        ) : (
          <Input
            {...sharedProps}
            value={value}
            type={type}
            variant={focused || isError ? "outlined" : variant}
            min={min}
            max={max}
            placeholder={placeholder}
            size={size}
            name={name}
            onPressEnter={handleKeyPress}
            onBlur={(e) => handleBlur(e)}
            onFocus={handleFocus}
            onChange={handleChange}
            style={style}
            disabled={isDisabled}
            suffix={suffix}
            addonbefore={addonbefore}
            addonafter={addonafter}
            status={isError ? "error" : undefined}
            prefix={prefix}
            required={required}
            autoFocus={autoFocus}
            focus={{ preventScroll: true, cursor: "end" }}
          />
        )}
        {/* Hover overlay with drop animation */}
        {hover && !disabled && !focused && (
          <SC.Overlay>
            <SC.ActionItem
              onClick={() => {
                setIsDisabled(false);
                setFocused(true);
                setTimeout(() => {
                  if (type !== "number" && inputRef.current) {
                    inputRef.current.focus({
                      preventScroll: true,
                      cursor: "end",
                    });
                  } else if (inputRef.current) {
                    inputRef.current.focus({ preventScroll: true });
                  }
                }, 100);
              }}
            >
              <EditOutlined /* style={{ fontSize: "14px" }} */ />
            </SC.ActionItem>
          </SC.Overlay>
        )}
      </SC.Wrapper>
    </>
  );
};

export default TableTextInput;
